import RenderNodeFactory from "./RenderNodeFactory";
import {augmentations} from "./augmentations";
import {ruleset} from "./renderRules";

const {renderNode, renderChildren, renderText} = RenderNodeFactory({
    ruleset,
    augmentations,
    modifiers: [],
});

export {renderNode, renderChildren, renderText};
